import PauseCardControlsTemporarilyPage from "components/pages/PauseCardControlsTemporarilyPage";
import React from "react";

export default function CapturePauseCardControls() {
    return <PauseCardControlsTemporarilyPage  />
}
